import styles from "./style.module.scss";

import DynamicForm from "@mavichpe/dynamic-forms";
import SendAtvDocumentToEmailFormConfig from "./form";
import { useEffect, useState } from "react";
import { SendDocumentDataType } from "@/formTypes/SendDocumentDataType";
import LoadingScreen from "@components/content/LoadingScreen";
import { showAlert } from "@utils/Alert";
import { getTenantId } from "@utils/Auth";
import { OpenSendAtvDocumentPubSubPayload } from "@utils/pubsubs/PubSub";
import { resendAtvDocument } from "@utils/EDocument";
import { useAppSelector } from "@/store/hooks";

export type EmailProps = {
  emailFilename: string,
  emailSubject: string,
  emailBody: string,
  emailTo?: string,
  Suscription: {
    email: string
  }
}

type SendAtvDocumentToEmailFormProps = {
  onSendForm: (data: SendDocumentDataType) => void,
  defaultData: SendDocumentDataType,
  beforeSend?: () => Promise<void>,
  innerForm?: boolean,
  documentData: OpenSendAtvDocumentPubSubPayload,
}

const SendAtvDocumentToEmailForm = (props: SendAtvDocumentToEmailFormProps) => {
  const { onSendForm, beforeSend, innerForm = false, defaultData, documentData = {} } = props;
  const [formConfig, setFormConfig] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const suscriptionData = useAppSelector(state => state.suscription.suscription);

  useEffect(() => {
    loadFormConfig();
  }, [])

  const onSubmit = async (formData: SendDocumentDataType) => {
    setIsLoading(true);
    try {
      if (beforeSend) {
        await beforeSend();
      }

      const response = await resendAtvDocument({
        ...documentData,
        clientEmail: `${formData.emails}`,
        Suscription: {
          ...documentData.Suscription,
          email: `${documentData.Suscription?.email || ""}`,
          use_easypos_email: suscriptionData?.use_easypos_email || false
        }
      });
      if (response.status) {
        showAlert("success", "Se ha enviado el documento correctamente")

      }
      if (onSendForm) {
        onSendForm(formData)
      }
    } catch (err) {
      if (err instanceof Error) {
        const errorMessage = err.message || "No fue posible enviar el correo electronico";
        showAlert("danger", errorMessage)
      }
    } finally {
      setIsLoading(false);
    }
  }

  const loadFormConfig = () => {
    setFormConfig(SendAtvDocumentToEmailFormConfig)
  }

  return (
    <>
      <DynamicForm<SendDocumentDataType>
        externalFormState={defaultData}
        innerForm={innerForm}
        formConfig={formConfig}
        onSubmit={onSubmit}
      >
      </DynamicForm>
      <LoadingScreen isLoading={isLoading} />
    </>

  )
}

export default SendAtvDocumentToEmailForm;